import { render, staticRenderFns } from "./custom-company-objective.vue?vue&type=template&id=30fac7ec&scoped=true&"
import script from "./custom-company-objective.vue?vue&type=script&lang=js&"
export * from "./custom-company-objective.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-objective.vue?vue&type=style&index=0&id=30fac7ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fac7ec",
  null
  
)

export default component.exports